import React from "react";
import ReadMoreReact from "read-more-react";
import ShowMoreText from "react-show-more-text";

import "./Blog.css";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import "./Blog.css";
const Post = ({ title, text, img, description, id }) => {
  return (
    <div className="blogArticle">
      <h1>{title}</h1>

      <div className="articleImg">
        <img src={img} alt="" />

        <div className="articleTitle">
          <p>
            {description}
            <Link className="open-post-btn" to={`/blog/${id}`}>
              למאמר במלואו
            </Link>
          </p>
        </div>
      </div>

      <div className="articleText"></div>
    </div>
  );
};

export default Post;
